module.exports = __webpack_public_path__ + "static/media/dennisderee.829920c1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/dennisderee.webp
// module id = 438
// module chunks = 0